import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useHistory, useLocation} from 'react-router-dom'
import {GET_PRODUCTS_BY_TAG, GET_SUB_HIERARCHIES} from '../../../store/queries'
import {
  ProductHierarcyEdge,
  Product,
  DocumentRelations,
  ProductHierarcy,
  ProductNode,
} from '../../../types'
import {useApolloClient} from '@apollo/client'
import {PageTitle} from '../../../../_metronic/layout/core'
import {appendPageLink, removePageLink} from '../../../../setup/redux/PageTitleSlicer'
import {RootState} from '../../../../setup/redux/RootReducer'
import {setMainLoading} from '../../../../setup/redux/loadingSlice'
import axios from 'axios'
import {API_URL} from '../../../../setup'
import AuthService from '../../../modules/auth/redux/AuthService'
import {Navigation} from 'swiper'
import {url} from 'inspector'
import "./SubHierarcy.css"

export default function SubHierarcyList() {
  const location = useLocation()
  const history = useHistory()
  const search = location.search
  let _parentProductHierarchyGuid = new URLSearchParams(search).get('guid')
  let _removeItem = new URLSearchParams(search).get('removeItem')
  let _tagText = new URLSearchParams(search).get('tagText')

  const [guidQuery, setGuidQuery] = useState<string | null>(_parentProductHierarchyGuid)
  const [tagText, setTagText] = useState<string | null>(_tagText)
  const user = AuthService.GetCurrentUser()
  const dispatch = useDispatch()

  const [productHierarchyList, setProductHierarchyList] = useState<ProductHierarcyEdge | undefined>(
    undefined
  )
  const [productList, setProductList] = useState<Product[] | undefined>(undefined)

  const pageLinks = useSelector((state: RootState) => state.pageLinkReducer)

  const client = useApolloClient()
  var cursor: string | undefined = undefined

  let images: any = {}
  images['no'] =
    'data:image/png;base64,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'

  useEffect(() => {
    setGuidQuery(_parentProductHierarchyGuid)
    console.log('tagtext', _tagText)
    setTagText(_tagText)
    console.log('PrevPage => ')
  })

  useEffect(() => {
    getList(guidQuery!)
  }, [guidQuery])

  useEffect(() => {
    getProducts(tagText!)
  }, [tagText])

  useEffect(() => {
    setProductHierarchyList(undefined)
    startWhile(true)
  }, [])

  async function startWhile(hasMore: boolean) {
    while (hasMore) {
      dispatch(setMainLoading(true))
      hasMore = await getList(undefined)
    }
    dispatch(setMainLoading(false))
  }
  const getProducts = async (tagText: string) => {
    dispatch(setMainLoading(true))
    var cursor2: string | undefined = undefined
    var buffer: Product[] = []

    async function startProductQuery(): Promise<any> {
      if (tagText != undefined && tagText !== '') {
        return await client
          .query({
            query: GET_PRODUCTS_BY_TAG,
            variables: {cursor, tagText: tagText},
          })
          .then((resp) => {
            console.log('taglist list => ', resp)
            if (resp.error) {
              return false
            } else {
              const pi = resp.data.products.pageInfo
              try {
                if (resp.data.products?.edges[0]?.node?.productProductHierarchies != undefined) {
                  console.log('ProductHierarchies 87 =>', resp.data.products?.edges[0])
                  var productsEntities: Product[] = resp.data.products.edges.map(
                    (productNode: ProductNode) => {
                      return productNode.node
                    }
                  )
                  buffer.push(...productsEntities)
                }
              } catch (err) {
                console.log('burada => ', err)
              }
              cursor = pi.endCursor
              return pi.hasNextPage
            }
          })
          .catch((err) => {
            console.log('error product list => ', err)
            return false
          })
      }
    }

    var hasMore = true
    let i: number = 0
    while (hasMore) {
      console.log('i => ', i++)
      hasMore = await startProductQuery()
      console.log('asdasd', hasMore)
    }
    console.log('320 buffer =>>', buffer)
    setProductList(buffer)
    dispatch(setMainLoading(false))
  }

  const downloadProduct = () => {
    var guidList = productList?.map((x) => x.guid.toString())

    var stringGuidList = guidList?.join('""')
    dispatch(setMainLoading(true))
    let url = API_URL + '/api/ExcelReport/ExcelReport'
    const token = user != null ? user.token : ''
    axios
      .post(
        url,
        {
          excelTemplateName: 'ProductExcelTemplate',
          query:
            'query{productsAll(where:{guid:{in:["' +
            stringGuidList +
            '"]}}){ productId,sku,displayName}}',
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            SessionGuid: user?.userData?.sessionGuid,
          },
          responseType: 'arraybuffer',
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'ürün listesi.xlsx')
        document.body.appendChild(link)
        link.click()
        dispatch(setMainLoading(false))
      })
      .catch((error) => console.log(error))
    dispatch(setMainLoading(false))
  }

  async function getList(hierarchyGuid: string | undefined): Promise<any> {
    let hierarchyCodeList: string[] = []

    if (hierarchyGuid != undefined && hierarchyGuid !== '') {
      return await client
        .query({
          query: GET_SUB_HIERARCHIES,
          variables: {
            cursor,
            topHieGuid: hierarchyGuid == undefined ? _parentProductHierarchyGuid : hierarchyGuid,
          },
        })
        .then((resp) => {
          console.log('haber list => ', resp)
          if (resp.error) {
            return false
          } else {
            const pi = resp.data.productHierarchies.pageInfo
            try {
              setProductHierarchyList(resp.data.productHierarchies)
              let products: Product[] | undefined =
                resp.data.productHierarchies?.edges[0]?.node?.products

              if (
                resp.data.productHierarchies?.edges[0]?.node?.productProductHierarchies != undefined
              ) {
                let productProductHieList =
                  resp.data.productHierarchies?.edges[0]?.node?.productProductHierarchies.map(
                    (x: any) => {
                      return x.product
                    }
                  )
                console.log('productProductHieList', productProductHieList)
                products = products?.concat(productProductHieList)
              }

              console.log('product list =>', products)
              setProductList(products)

              if (hierarchyGuid == undefined && (_removeItem == undefined || _removeItem == '')) {
                dispatch(
                  appendPageLink({
                    isActive: true,
                    path: '/',
                    title: 'Ana Sayfa > ',
                  })
                )
              } else {
                if (_removeItem != undefined && _removeItem != '') {
                  console.log('_removeItem =>', _removeItem)
                  dispatch(removePageLink(_removeItem))
                } else {
                  dispatch(
                    appendPageLink({
                      isActive: true,
                      path:
                        '/subHierarchyList?guid=' +
                        productHierarchyList?.edges[0]?.node.guid +
                        '&removeItem=' +
                        productHierarchyList!.edges[0]!.node.displayName +
                        ' > ',
                      title: productHierarchyList!.edges[0]!.node.displayName + ' > ',
                    })
                  )
                }
              }
            } catch (err) {
              console.log('burada => ', err)
            }
            cursor = pi.endCursor
            return pi.hasNextPage
          }
        })
        .catch((err) => {
          console.log('error activity list => ', err)
          return false
        })
    }
  }

  const getImage = (productHie: ProductHierarcy) => {
    if (productHie.documentRelations != undefined && productHie.documentRelations.length > 0) {
      return productHie.documentRelations[0].document.fileName
    } else {
      return images['no']
    }
  }

  const updateBreadCrump = () => {
    if (productHierarchyList && productHierarchyList.edges && productHierarchyList.edges[0]) {
      dispatch(
        appendPageLink({
          isActive: true,
          path:
            '/subHierarchyList?guid=' +
            productHierarchyList.edges[0].node.guid +
            '&removeItem=' +
            productHierarchyList.edges[0].node.displayName +
            ' > ',
          title: productHierarchyList.edges[0].node.displayName + ' > ',
        })
      )
    }
  }

  const getProductImage = (documentRelationList: DocumentRelations[] | undefined) => {
    if (documentRelationList == undefined || documentRelationList.length == 0) {
      return images['no']
    }

    return documentRelationList[0].document.fileName + '?w=370&h=250&mode=pad'
  }

  return (
    <>
      <PageTitle breadcrumbs={pageLinks.PageLinkList}>
        {productHierarchyList?.edges[0]?.node.displayName}
      </PageTitle>

      <div className='card card-stretch mb-5 mb-xxl-8'>
        <div className='card-body'>
          <div className=''>
            <h1
              className='mb-5'
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignContent: 'flex-end',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              {_tagText! ? tagText : productHierarchyList?.edges[0]?.node.displayName}
            </h1>
            <div className='row'>
              {productHierarchyList?.edges[0]?.node.subProductHierarchies?.map((x) => (
                <div className='col-md-3' key={x.guid}>
                  <div className='card-xl-stretch'>
                    <Link
                      className='d-block overlay mb-4'
                      to={{search: 'guid=' + x.guid}}
                      onClick={() => {
                        setGuidQuery(x.guid)
                      }}
                    >
                      <div
                        className=''
                        style={{
                          height: '250px',
                          backgroundImage: `url(${getProductImage(x.documentRelations)})`,
                          backgroundPosition: 'center',
                        }}
                      >
                        {/* <img 
                                                src={getProductImage(x.documentRelations)} 
                                                style={{objectFit: 'contain'}} width='370' height={'250'} alt='Product' /> */}
                      </div>
                    </Link>
                    <div className='m-0 text-center'>
                      <Link
                        to={{search: 'guid=' + x.guid}}
                        className='fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base '
                      >
                        {x.displayName}
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className='row mt-15'>
              <div className='col-md-11'>
                <h2
                  style={{
                    display: productList != undefined && productList.length > 0 ? 'block' : 'none',
                  }}
                >
                  Ürünler({productList?.length})
                </h2>
              </div>

              <div className='col-md-1 excelButton'>
                {productList! && productList.length > 0 && (
                  <button
                    type='button'
                    className='btn btn-sm btn-success'
                    onClick={(event) => downloadProduct()}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-file-earmark-excel-fill'
                      viewBox='0 0 16 16'
                    >
                      <path d='M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z' />
                    </svg>
                  </button>
                )}
              </div>
            </div>

            <div className='row mt-15'>
              {productList?.map((x) => (
                <div className='col-md-4 mb-6' key={x.guid}>
                  <div className='card-xl-stretch'>
                    <Link
                      className='d-block overlay m-6'
                      to={'/productDetail?guid=' + x.guid}
                      onClick={() => updateBreadCrump()}
                    >
                      <div
                        className='overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded m-auto'
                        style={{width: '100%', height: '250px'}}
                      >
                        <Link
                          to={'/productDetail?guid=' + x.guid}
                          className='fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base '
                        >
                          <img
                            src={getProductImage(x.documentRelations)}
                            style={{objectFit: 'contain'}}
                            width='100%'
                            height={'250px'}
                            alt='Product'
                          />
                        </Link>
                      </div>
                    </Link>
                    {console.log('X ==>>> ', x)}
                    <div className='m-0 text-center'>
                      <Link
                        to={'/productDetail?guid=' + x.guid}
                        className='fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base '
                      >
                        {x.displayName}
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
